import { useTemplateListContext } from '@/contexts/TemplatesContext';

import { Button } from '../ui/button';

const TemplateListTableError = () => {
  const { error, refetch } = useTemplateListContext();

  return (
    <div className="rounded-md bg-red-50 p-4">
      <div className="flex">
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            Error loading templates
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <p>{error}</p>
          </div>
          <div className="mt-4">
            <Button type="button" variant="outline" size="sm" onClick={refetch}>
              Try again
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateListTableError;
